import gql from 'graphql-tag';

export default gql`
    mutation removeAffiliateSeller {
        payload: removeAffiliate {
            ... on RemoveAffiliateSuccess {
                successful
            }   
    
            ... on RemoveAffiliateFailure {
                successful
            }
        }
    }
`;
